import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';

export const checkPinCodeService = (pinCode: number) => {
  const url = getUrl(ROUTES.PIN_CODE_SERVICE);
  const body = { pincode: String(pinCode) };

  return ApiHelper(url, { method: 'POST', body, isBodyJSON: true })
    .then((response: Response) => {
      return response.json();
    })
    .catch(() => Promise.reject({ statusCode: 500 }));
};
